import Rails from "@rails/ujs";
import * as bootstrap from 'bootstrap/dist/js/bootstrap';
import * as echarts from 'echarts';
//import 'echarts';
import 'echarts/theme/dark';

Rails.start();

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

window.echarts = echarts;

// HACK Rerender charts on modal show
// https://github.com/apache/echarts/issues/10478
// https://github.com/railsjazz/rails_charts/blob/b424bd1eb0a047080afb66a939ae6279f49bb82c/lib/rails_charts/base_chart.rb#L47
window.addEventListener('load', () => {
  // Ones in a modal should be rerendered on modal show
  const instrumentModals = document.querySelectorAll('.instrument-modal, .displayable-index-modal');
  instrumentModals.forEach(instrumentModal => {
    instrumentModal.addEventListener('shown.bs.modal', event => {
      const ohlcChartWrappers = event.target.querySelectorAll('.ohlc-chart');
      ohlcChartWrappers.forEach(ohlcChartWrapper => {
        if (window.RailsCharts.charts[ohlcChartWrapper.id]) {
          window[`destroy_${ohlcChartWrapper.id}`]();
        }
        window[`init_${ohlcChartWrapper.id}`]();
      });

      // Radar charts
      const radarChartWrapper = event.target.querySelector('.instrument-radar-chart');
      if (radarChartWrapper) {
        if (window.RailsCharts.charts[radarChartWrapper.id]) {
          window[`destroy_${radarChartWrapper.id}`]();
        }
        window[`init_${radarChartWrapper.id}`]();
      }
    });
  });

  // Ones not in a modal should be rerendered on window resize
  window.addEventListener('resize', () => {
    const ohlcChartWrappers = document.querySelectorAll('.ohlc-chart');
    ohlcChartWrappers.forEach(ohlcChartWrapper => {
      if (window.RailsCharts.charts[ohlcChartWrapper.id]) {
        window[`destroy_${ohlcChartWrapper.id}`]();
      }
      window[`init_${ohlcChartWrapper.id}`]();
    });

    // Radar charts
    const radarChartWrappers = event.target.querySelectorAll('.instrument-radar-chart');
    radarChartWrappers.forEach(radarChartWrapper => {
      if (window.RailsCharts.charts[radarChartWrapper.id]) {
        window[`destroy_${radarChartWrapper.id}`]();
      }
      window[`init_${radarChartWrapper.id}`]();
    });
  });
});

// Saved screening param sets
document.addEventListener('DOMContentLoaded', function() {
  const uidSelectors = document.querySelectorAll('.screening-filter-selector');
  uidSelectors.forEach((uidSelector) => {
    uidSelector.addEventListener('change', (e) => {
      const uid = e.target.value;
      const url = new URL(window.location.href);
      url.pathname = '/compass';
      url.search = '';

      if (uid) {
        url.searchParams.set('screening_param_set_uid', uid);
      } else {
        url.searchParams.delete('screening_param_set_uid');
      }
      window.location.href = url.toString();
    });
  });
});

// Generic tooltip
// https://getbootstrap.com/docs/5.0/components/tooltips/#example-enable-tooltips-everywhere
document.addEventListener("DOMContentLoaded", function() {
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  });
});

